import { render, staticRenderFns } from "./AddToLibraryModal.vue?vue&type=template&id=2cbf458b&"
import script from "./AddToLibraryModal.vue?vue&type=script&lang=js&"
export * from "./AddToLibraryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports